import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';

import React from 'react';
import classname from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import apiUpgradeImage from './images/api-upgrade.svg';
import { messages } from './messages';
import style from './style.module.less';
import { InventoryApiUrl } from '../../../../../../constants/add-ons';
import { linkIDs } from '../../../../../../services/link-service/links';
import { useSupportLink } from '../../../hooks';

/**
 * When the Seller does not have API Access or the Inventory Addon we will show this banner along with the
 * impossibility to generate API keys (v1 & v2)
 * @param {object} props
 * @param {string} props.className
 * @returns {JSX.Element} The rendered component.
 */
export const PlanUpgradeBanner = ({ className }) => {
  const intl = useIntl();
  const link = useSupportLink(linkIDs.PaymentAndSubscriptionSettings);

  return (
    <section className={classname(style['plan-upgrade-banner-wrapper'], className)}>
      <article className={style['content-and-button-wrapper']}>
        <div className={style['content-wrapper']}>
          <Text className={style['plan-upgrade-banner-heading']} element='h3' textType={TextType.H3} value={messages.title} />
          <Text element='p' textType={TextType.Paragraph} value={messages.firstParagraph} />
          <br />
          <Text element='p' textType={TextType.Paragraph} value={messages.secondParagraph} />
        </div>

        <div className={style['button-wrapper']}>
          <Button className={style['upgrade-banner-button']} href={link} theme={THEME_CONSTANTS.promotional}>
            <FontAwesomeIcon className={style.icon} icon={faBolt} />
            <FormattedMessage {...messages.upgradeButtonLabel} />
          </Button>

          <Button className={style['enable-inventory-button']} href={InventoryApiUrl} theme={THEME_CONSTANTS.secondary}>
            <FormattedMessage {...messages.enableInventoryButtonLabel} />
          </Button>
        </div>
      </article>

      <article className={style['image-wrapper']}>
        <img alt={intl.formatMessage(messages.imageAlt)} src={apiUpgradeImage} />
      </article>
    </section>
  );
};
